<template>
  <div class="user-sign">
    <el-card style="width: 100%; height: 100%; box-sizing: border-box">
      <div slot="header" style="font-weight: bold; font-size: 18px">
        用户信息
      </div>

      <el-form
        ref="form"
        :model="UserInfo"
        label-width="100px"
        label-position="left"
        v-if="!isOver"
      >
        <el-form-item label="账号">
          <el-input v-model="UserInfo.AccountName" disabled></el-input>
        </el-form-item>
        <el-form-item label="名称">
          <el-input v-model="UserInfo.PMC_Name" disabled></el-input>
        </el-form-item>
        <el-form-item label="联系人">
          <el-input v-model="UserInfo.Person"></el-input>
        </el-form-item>
        <el-form-item label="签名">
          <div
            @click="signVisible = true"
            style="
              height: 100px;
              border: 1px solid #ccc;
              line-height: 100px;
              text-align: center;
              width: 100%;
              box-sizing: border-box;
              background-color: #fff;
            "
            v-if="!UserInfo.Sign"
          >
            点击预制签名
          </div>
          <!-- transform: rotate(-90deg); -->
          <div
            style="
              display: flex;
              align-items: center;
              justify-content: center;
              height: 100px;
              text-align: center;
              box-sizing: border-box;
              overflow: hidden;
              width: 100%;
              height: 100px;
              border: 1px solid #ccc;
            "
            @click="signVisible = true"
            v-if="UserInfo.Sign"
          >
            <img
              :src="UserInfo.Sign"
              alt=""
              style="
                width: 100%;
                background: #fff;
                box-sizing: border-box;
                height: 100px;
              "
            />
          </div>
        </el-form-item>
        <el-form-item>
          <el-button
            size="mini"
            type="primary"
            @click="onSubmitUserInfo"
            :loading="loading"
            style="width: 100%"
            >保存
          </el-button>
        </el-form-item>
      </el-form>
      <el-result
        icon="success"
        title="修改成功"
        subTitle="PC浏览器请刷新浏览器页面"
        v-if="isOver"
      >
        <template slot="extra">
          <!-- <el-button type="primary" size="medium" @click="close()">退出</el-button> -->
        </template>
      </el-result>
    </el-card>

    <div
      v-if="signVisible"
      style="
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 99;
      "
    >
      <sign
        @close="signVisible = false"
        @success="signSub"
        :useSing="false"
      ></sign>
    </div>
  </div>
</template>
<script>
import TokenCache from '@/utils/cache/TokenCache'
import sign from '@/components/Sign/sign.vue'
export default {
  data() {
    return {
      token: '',
      signVisible: false,
      UserInfo: {},
      loading: false,
      isOver: false,
    }
  },
  props: {},
  components: { sign },
  methods: {
    close() {
      window.close()
    },
    onSubmitUserInfo() {
      this.loading = true

      this.$http
        .post('/PB/PB_Project/SaveTransferRouteData', {
          UserName: this.UserInfo.AccountName,
          RealName: this.UserInfo.Person,
          TransferRoute: JSON.stringify(this.UserInfo),
        })
        .then(async (res) => {
          this.loading = false
          if (res.Success) {
            this.isOver = true
            this.$notify.success('保存成功')
          } else this.$notify.error(res.Msg)
        })
    },
    signSub(url) {
      this.signVisible = false
      this.UserInfo.Sign = url
    },
    getUserInfo() {
      this.loading = true

      this.$http.post('/Base_Manage/Home/GetOperatorInfo').then((res) => {
        this.loading = false

        if (res.Success) {
          this.UserInfo = res.Data.UserInfo
          this.$store.commit('setUserInfo', res.Data.UserInfo)
          window.localStorage.setItem(
            'userInfo',
            JSON.stringify(res.Data.UserInfo)
          )
        }
      })
    },
  },
  mounted() {},
  created() {
    this.token = this.$route.query.token
    TokenCache.setToken(this.$route.query.token)
    console.log(this.token)
    if (this.token) {
      this.getUserInfo()
    }
  },
  computed: {},
  watch: {},
}
</script>
<style lang="scss" scoped>
.user-sign {
  width: 100%;
  height: 100%;
  background-color: #ededed;
}
</style>
